import React from 'react';

/**
 * Renders CMS HTML on public pages with stronger copy/selection discouragement.
 * Does not replace server-side or DevTools access — best-effort UX friction only.
 */
function stopCopyAndContextMenu(e) {
  e.preventDefault();
}

/** Plain text / React children — same copy & selection rules as {@link PublicProtectedHtml}. */
export function PublicProtectedBlock({ className = '', children, ...rest }) {
  const { className: restClass, ...divProps } = rest;
  const mergedClass = ['public-content-protected', className, restClass].filter(Boolean).join(' ');
  return (
    <div
      {...divProps}
      className={mergedClass}
      onCopy={stopCopyAndContextMenu}
      onCut={stopCopyAndContextMenu}
      onContextMenu={stopCopyAndContextMenu}
      onDragStart={stopCopyAndContextMenu}
    >
      {children}
    </div>
  );
}

export default function PublicProtectedHtml({ className = '', html, ...rest }) {
  const { className: restClass, ...divProps } = rest;
  const mergedClass = ['public-content-protected', className, restClass].filter(Boolean).join(' ');
  return (
    <div
      {...divProps}
      className={mergedClass}
      onCopy={stopCopyAndContextMenu}
      onCut={stopCopyAndContextMenu}
      onContextMenu={stopCopyAndContextMenu}
      onDragStart={stopCopyAndContextMenu}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
